export default __webpack_public_path__ + "4d2e8014df4bd73f34a8277d25ea55e4.png";